import request from '@/utils/request'
const apiPath = '/user/businessProcessing'
import qs from 'qs'
const businessProcessingApi = {
  /**
   * 新增【我的线索】
   */
  create(data) {
    return request.post(`${apiPath}/myClue`, data)
  },
  /**
   * 修改【我的线索】
   */
  update(data) {
    return request.put(`${apiPath}/myClue`, data)
  },
  /**
   * 分页查询【业务管理-业务审核列表】
   */
  fetchList(query) {
    return request.get(`${apiPath}/findCustomerListByPage`, { params: query })
  },
  /**
   * 分页查询【财务管理-子账号审核列表】
   */
  findSubAccountList(query){
    return request.get(`${apiPath}/findSubAccountList`, { params: query })
  },
  /**
   * 查看【业务管理-业务审核】详情
   */
  fetchById(query) {
    return request.get(`${apiPath}/findBusinessProcessingCustomerDetailById`,{ params: query })
  },
  /**
   * 分页查询【财务管理-业务审核列表】
   */
  getList(query) {
    return request.get(`${apiPath}/findFinanceListByPage`, { params: query })
  },
  /**
   * 删除单个【我的线索】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/myClue/${id}`)
  },
  /**
   * 批量删除【我的线索】
   */
  deleteBatch(ids) {
    return request.delete(`${apiPath}/myClue`, { data: ids })
  },
  // 获取子账号详情
  findByzzh(query){
    // const data = qs.stringify(params, { arrayFormat: 'repeat' });
    return request.get(`${apiPath}/findByzzh`,{ params: query })
  },
  // 查询子账号
  findSubAccountListPage(query){
    return request.get(`${apiPath}/findSubAccountList`,{ params: query })
  },
  exportExcel(data){
    return request.post(apiPath + '/findFinanceExport', data)
  },
  // setIsEnableExpress(data) {
  //   return request.put(apiPath + '/tee/setIsEnable', data)
  // },
  findSubAccountApplyInfo(query){
    return request.get(`${apiPath}/findSubAccountApplyInfo`,{ params: query })
  }
}
export default businessProcessingApi
